// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"490601af","230":"875aceb3","270":"9ef3c058","436":"a8681eb8","495":"304aad11","593":"92d8c442","631":"67bd41cb","720":"9cbcda98","877":"41f1eabc"}[chunkId] + ".chunk.js";
};